import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Collaborator } from './types'

export const CREATE_COLLABORATOR: TypedDocumentNode<
  { createCollaborator: Collaborator },
  {
    client_id: string
    application_id: string
    name: string
    role?: string | null
    email?: string | null
    info?: string | null
    collaborators_functions?: string[] | null
    image?: string | null
    observations?: string | null
    sort_order?: number | null
    pastor_order?: number | null
    pastor_rank?: number
  }
> = gql`
  mutation CreateCollaborator(
    $client_id: ID!
    $application_id: ID!
    $name: String!
    $role: String
    $email: String
    $info: String
    $collaborators_functions: [String!]
    $image: String
    $observations: String
    $sort_order: Int
    $pastor_order: Int
    $pastor_rank: Int
  ) {
    createCollaborator(
      client_id: $client_id
      application_id: $application_id
      name: $name
      role: $role
      email: $email
      info: $info
      collaborators_functions: $collaborators_functions
      image: $image
      observations: $observations
      sort_order: $sort_order
      pastor_order: $pastor_order
      pastor_rank: $pastor_rank
    ) {
      id client_id application_id name role email info collaborators_functions image image_low_res observations sort_order pastor_order pastor_rank created_at updated_at
    }
  }
`

export const UPDATE_COLLABORATOR: TypedDocumentNode<
  { updateCollaborator: Collaborator },
  {
    id: string
    name?: string
    role?: string | null
    email?: string | null
    info?: string | null
    collaborators_functions?: string[] | null
    image?: string | null
    observations?: string | null
    sort_order?: number | null
    pastor_order?: number | null
    pastor_rank?: number
  }
> = gql`
  mutation UpdateCollaborator(
    $id: ID!
    $name: String
    $role: String
    $email: String
    $info: String
    $collaborators_functions: [String!]
    $image: String
    $observations: String
    $sort_order: Int
    $pastor_order: Int
    $pastor_rank: Int
  ) {
    updateCollaborator(
      id: $id
      name: $name
      role: $role
      email: $email
      info: $info
      collaborators_functions: $collaborators_functions
      image: $image
      observations: $observations
      sort_order: $sort_order
      pastor_order: $pastor_order
      pastor_rank: $pastor_rank
    ) {
      id client_id application_id name role email info collaborators_functions image image_low_res observations sort_order pastor_order pastor_rank created_at updated_at
    }
  }
`

export const DELETE_COLLABORATOR: TypedDocumentNode<
  { deleteCollaborator: boolean },
  { id: string }
> = gql`
  mutation DeleteCollaborator($id: ID!) {
    deleteCollaborator(id: $id)
  }
`
